<template>
    <div class="ws-page">
        <PageSpinner :onloader="loader" />
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <router-link to="/dashboard" class="text-white">
                Dashboard
            </router-link>
            <router-link v-if="parentPath" :to="parentPath" class="text-white">
                <i class="fa fa-ellipsis-v px-2"></i>{{ parentLabel }}
            </router-link>
            <span class="text-white"><i class="fa fa-ellipsis-v px-2"></i>{{ pageLabel }}</span>
        </base-header>

        <div class="container-fluid mt--7 ws-page__body">
            <section class="ws-panel" :aria-labelledby="headingId">
                <header class="ws-panel__intro">
                    <div class="ws-panel__text">
                        <span v-if="eyebrow" class="ws-eyebrow">{{ eyebrow }}</span>
                        <h1 :id="headingId">{{ title }}</h1>
                        <p v-if="description">{{ description }}</p>
                    </div>
                    <div class="ws-panel__side">
                        <slot name="side"></slot>
                    </div>
                </header>

                <header v-if="hasToolbar" class="ws-toolbar">
                    <div>
                        <h2>{{ toolbarTitle }}</h2>
                        <p v-if="meta" class="ws-toolbar__meta">{{ meta }}</p>
                    </div>
                    <div class="ws-toolbar__tools">
                        <slot name="toolbar"></slot>
                    </div>
                </header>

                <slot></slot>
            </section>
        </div>
    </div>
</template>

<script>
import PageSpinner from "@/components/PageSpinner";

let headingSequence = 0;

export default {
    name: "SetupPage",
    components: {
        PageSpinner
    },
    props: {
        loader: {
            type: String,
            default: "none"
        },
        parentLabel: {
            type: String,
            default: "Academic Management"
        },
        parentPath: {
            type: String,
            default: "/school/academic-management"
        },
        pageLabel: {
            type: String,
            required: true
        },
        eyebrow: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            default: ""
        },
        hasToolbar: {
            type: Boolean,
            default: true
        },
        toolbarTitle: {
            type: String,
            default: "Registered records"
        },
        meta: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            headingId: `ws-page-title-${++headingSequence}`
        };
    }
};
</script>
